import atimg6 from '../images/team/christine.jpg'
import atimg2 from '../images/team/diana.jpg'
import atimg5 from '../images/team/sandra.jpg'
import atimg7 from '../images/team/nora.jpg'
import atimg3 from '../images/team/mendi.jpg'
import atimg1 from '../images/team/michael.jpg'
import atimg4 from '../images/team/starggieh.jpg'


const Attorneys = [
    {
       Id:'1',
       AtImg:atimg1,
       name:'A.M Otieno',
       title:'Managing Partner',
       social:'https://www.linkedin.com/in/michael-owano-a7580a121/',
       experience:'5',
       experienceDesc:`
         <h5>LL.B Hons (Moi), CPM (MTI), PGD Law (KSL).</h5>
         Michael is a result-oriented litigation attorney & founding partner of Otieno M.O Law Advocate. He brings to the firm years of experience in a wide range of legal practice having previously practiced as a Senior Associate at Humphrey & Company LLP Advocates, these are including but not limited to 
         <ul>
         <li> -  <small> Insurance Law i.e. personal injury, Recovery Claims, Subrogation of Rights, Material damage Claims and Insurance Fraud.</small></li>
         <li> -  <small> Banking Law i.e. Debt Recovery, Security and Documentation Fraud and Investigation.</small></li>
         <li> -  <small> Intellectual Property; Registration and Enforcement of Intellectual property Rights and Intellectual Property Litigation.</small></li>
         <li> -  <small> Employment and Labor Relations including Wrongful Termination Suits, Negotiation of Collective Bargaining Agreements, Employee Code of Conduct design and implementation process.</small></li>
         <li> -  <small> Alternative Dispute Resolution i.e. Arbitration, Mediation and Negotiation.</small></li>
         <li> -  <small> Competition Law including Mergers & Acquisitions, Abuse of Buyer Power and Monopoly Investigations.</small></li>
         </ul>
         <p>He is capable of identifying and strategizing dispute resolutions from a client base perspective with ease and he is aware of the duty of implementing corporate policies, general litigation and appreciation of the need to resolve disputes expeditiously and economically viable to the client. He has acted as litigation counsel for various local and multinational corporations and private persons in disputes across a broad range of sectors as enunciated.</p>
         <p>Michael holds an LLB from Moi University and a postgraduate diploma in Legal Practice from the Kenya School of Law. He has previously acted for both local and international corporate clientele including MUA Insurance Company Kenya Limited (formerly Saham Assurance Limited), KCB Bank Kenya Limited, Multichoice Kenya Limited, Shoprite Checkers Kenya Limited, National Water Harvesting Authority, National Museums of Kenya & Kenya Power & Lighting Company Limited.</p>
       .`,
       language:'English (fluent)',
       edu1:'Moi University School of Law',
       edu2:'Kenya School of Law'

    },
    {
       Id:'2',
       AtImg:atimg2,
       name:'Diana Ahono',
       title:'Associate',
       social:'https://www.linkedin.com/in/diana-ruth-ahono-41bb6a163/',
       experience:'2',
       experienceDesc:`
       <h5>LL.B Hons (UoN), PGD Law (KSL).</h5>

       <p>Diana is an advocate of the High Court having been admitted to the Bar of Advocates. She has previously practiced as an advocate in the firm of Messrs
       Lestins & Smith Advocates as an associate.</p>
       <p>Her experience spans the fields of:</p>
       <ul>
       <li> -  <small>civil and criminal litigation.</small></li>
       <li> -  <small>commercial litigation.</small></li>
       <li> -  <small>Intellectual Property Law.</small></li>
       <li> -  <small>constitutional litigation.</small></li>
       <li> -  <small>insurance law.</small></li>
       <li> -  <small>conveyancing/property law among others.</small></li>
       </ul>
       
       <p>Diana is a holder of a Law Degree from the University of Nairobi, Post graduate Diploma from the Kenya School of Law, Post Graduate Diploma on Maritime law from the University of Nairobi and is also a Member of the Law Society of Kenya and the East Africa Law Society.</p>
              
       `,
       language:'English (fluent)',
       edu1:'University of Nairobi',
       edu2:'Kenya School of Law'
    },
    {
       Id:'3',
       AtImg:atimg3,
       name:'Mendi Faraay',
       title:'Associate',     
       social:'https://www.linkedin.com/in/mendi-faraay-b41834204/',
       experience:'3',
       experienceDesc:`
       <h5>LL.B Hons (CUEA), PGD Law (KSL).</h5>

       <p>Mendi is an advocate of the High Court of Kenya having been admitted to the bar. She is an Associate in the Commercial and Conveyancing Department.
       She is knowledgeable in:</p>
       <ul>
       <li> -  <small>Civil law.</small></li>
       <li> -  <small>Conveyancing and Property law.</small></li>
       <li> -  <small>Constitutional law.</small></li>
       <li> -  <small>Insurance law.</small></li>
       <li> -  <small>Banking and Securitization.</small></li>
       <li> -  <small>Company Law.</small></li>
       <li> -  <small>Probate and Administration law.</small></li>
       <li> -  <small>Family law.</small></li>
       <li> -  <small>Human Rights and Criminal law.</small></li>
       <p>She has experience in:</p> 
       <li> -  <small>Reparation and registration of security documents such as charges and debentures.</small></li>
       <li> -  <small>Advising clients in various property transactions.</small></li>
       <li> -  <small>Carrying out legal research on various areas of the law.</small></li>
       <li> -  <small>Carrying out due diligence for financial institutions and various corporations.</small></li>
       <li> -  <small>Handling the incorporation of companies. Handling personal injuries claims on behalf of insurance companies.</small></li>
       </ul>
       <p>Mendi holds a Bachelor of Laws Degree from The Catholic University of Eastern Africa, Post graduate Diploma in law from the Kenya School of Law and is a member of the Law Society of Kenya and East Africa Law Society.</p>
              
       `,
       language:'English (fluent)',
       edu1:'Catholic University of East Africa',
       edu2:'Kenya School of Law'
    },
    {
       Id:'4',
       AtImg:atimg4,
       name:'Starggieh Nthiga',
       title:'Consultant',
       social:'',
       experience:'6',
       experienceDesc:`
       <h5>M. Econ; B. Econ; BCom- Finance; Bsc. (Act. Sci.); CPA-K.</h5>
       <p>Starggieh is a consultant and also heads the Consultancy, Research and Development Department at the firm. She is a financial consultant and an advanced taxation expert. She brings over 5 years part-time experience and 3 years post-graduate experience and in depth knowledge about corporate finance functionality of various industries.</p>
       
       <p>Starggieh firmly believes in innovation that involves assessing new and existing realities and opportunities. She has been instrumental in encouraging organizations to embrace innovation for sustainability and growth in the highly competitive markets. She practices adherence to best practices in both managerial and strategic projects and operations.</p>
       
       <p>Starggieh is an economics, Acturial Management, Accounting and Finance Professional who has served as an Auditor for reputable organizations including KPMG. In this capacity at the firm, she has improved our client’s financial status by providing effective solutions to complex accounting issues, assurance services, tax advisory and business advice to large manufacturing, distribution technology, large corporate and multinational clientele.</p>
       
       <p>She has previously worked as an underwriter at CIC Insurance where she successfully saved the company finances by ensuring proper and accurate debting and crediting of both new business and renewal policies.</p>
       
       </p>She is a holder of Master of Economics from Jomo Kenyatta University of Agriculture and Technology. This is in addition to Bachelor of Economics and Bachelor of Science in Actuarial Science degrees from the same institution and a Bachelor of Commerce in Finance Degree from the University of Nairobi. She is also a Certified Public Accountant- Kenya (CPA-K) and a member of the Institute of Certified Public Accountants of Kenya (ICPAK) and the Institute of Internal Auditors (IIA).</p>
                     
       `,
       language:'English (fluent)',
       edu1:'Jomo Kenyatta University of Agriculture and Technology',
       edu2:''
       
    },
    {
      Id:'5',
      AtImg:atimg5,
      name:'Sandra Akama',
      title:'Consultant',
      social:'https://www.linkedin.com/in/sandra-akama/',
      experience:'4',
      experienceDesc:`
      <h5>Ph.d (Candidate) LL.M (UoN), LL.B Hons (UoN) PGD Law (KSL), CPA.</h5>
      <p>Sandra is an advocate of the High Court of Kenya with a wealth of experience in various areas of law. Sandra also has experience in a range of dispute resolution matters including:</p>
      <ul>
      <li> -  <small>Ddebt recovery.</small></li>
      <li> -  <small>Real estate and land disputes.</small></li> 
      <li> -  <small>Employment and labour relations disputes.</small></li>
      <li> -  <small>Intellectual property disputes.</small></li>
      <li> -  <small>Tax litigation.</small></li>
      <li> -  <small>International and local arbitration,.</small></li>
      <li> -  <small>Alternative dispute resolution.</small></li>
      <li> -  <small>Advisory and general dispute resolution.</small></li>
      ,/ul>
      <P>As a non-resident consultant to the firm, Sandra brings onboard a wealth of experience given her prowess in legislative drafting. Previously, having worked for the Kenya Law Reform Commission (KLRC) as an assistant legal researcher where she contributed to the drafting of several Bills which were later passed by Parliament to become laws these include;</P>
      <ul>
      <li> -  <small>Childrens’ Act 2022.</small></li>
      <li> -  <small>Person with Disabilities (Amendment) Bill 2020.</small></li>
      <li> -  <small>The Kenya Film Bill 2020 among others.</small></li>
      </ul>
      <p>She was also instrumental in the development and review of government policies and sessional papers which have formed the hall mark of several sectors in government including Kenya film Policy among others.</p>
      <p>Sandra has further contributed to the legislative process as she worked for the Parliamentary Service commission where she provided quality legal opinions and legal advice on litigation, compliance, policy, procedural and corporate management of the Houses of Parliament and provided legal opinions on Judgments and Rulings of court to guide in the legislative process.</p>
      <p>Sandra is currently pursuing a Doctor of Philosophy in law at the University of Nairobi. This is in addition to Master of Laws (LLM) and a Bachelor’s Degree in Laws (LLB) from the same university. She also holds a post-graduate diploma from the Kenya School of Law and is also Certified Public Accountant- (CPA) from the Strathmore University- School of Accountancy. Sandra is also a member of the Law Society of Kenya and the East Africa Law Society.</p>
            
      `,
      language:'English (fluent)',
      edu1:'University of Nairobi',
      edu2:'Strathmore University'
   },
   {
      Id:'6',
      AtImg:atimg6,
      name:'Christine Ogega',
      title:'Consultant',     
      social:'https://www.linkedin.com/in/christine-ogega-280643194/',
      experience:'4',
      experienceDesc:`
      <h5>LL.B Hons (Kisii), PGD Law (KSL), CPS (K).</h5>
      <p>Christine is an advocate of the High court of Kenya with a wealth of experience in corporate laws and specialization in:</p>
      <ul>
      <li> -  <small>Banking Law and Financial Securities.</small></li>
      <li> -  <small>She worked on various projects as both lead and care counsel for clients housing development projects.</small></li>
      <li> -  <small>She has experience in Bank Securitization.</small></li>
      <li> -  <small>Conveyancing and Property Law.</small></li>
      <li> -  <small>Commercial transactions.</small></li> 
      <li> -  <small>Intellectual Property Law and Litigation.</small></li>
      </ul>
      <p>Christine is also a data compliance expert in data protection trainings in line with the Data Protection Act 2019.
      As a non-resident consultant in the firm, Christine brings on board an assortment of experience given her understanding of the banking sector in Kenya and internationally. She has equally specialized in Anti- Money Laundering and conducted trainings to this effect.</p>
      <p>Christine is a holder bachelor of laws Degree from Kisii University and a post graduate diploma in law from the Kenya School of Law. She is also a Certified Company Secretary from the Institute of Certified Secretaries (ICS). She is a member of the Law Society of Kenya, East Africa Law Society and the Institute of Certified Secretaries (ICS).</p>
            
      `,
      language:'English (fluent)',
      edu1:'Kisii University',
      edu2:'Kenya School of Law'
   },
   {
      Id:'7',
      AtImg:atimg7,
      name:'Nora Sandhu',
      title:'Administrator',
      social:'https://www.linkedin.com/in/nora-sandhu-29b7aa189/',
      experience:'2',
      experienceDesc:`
      <h5>B.A Criminology (Egerton)].</h5>
      <p>Nora is the office Administrator at the firm of Otieno M.O Law Advocate. She brings to the firm a wealth of experience in the running of day to activities of the firm having previously worked for multi-national corporations in the same capacity
      Besides handling the firm’s activities, as the Office Administrator, she is responsible for cultivating partnerships and maintaining commercial relationships with our clients.</p><p> Together with the management of the firm, she ensures our client’s needs are increasingly meet in a timely manner. 
      Nora is a holder of a Bachelor’s degree in Criminology and Security Studies from Egerton University. This is in addition to a Higher Diploma in Forensic Psychology and Criminology from the Institute of Criminal Justice and also a Diploma in Criminology from the same institution.</p>
            
      `,
      language:'English (fluent)',
      edu1:'Kenya Institute of Criminal Justice',
      edu2:'Egerton University'
   }          
    
]

export default Attorneys;